import React, { Component } from "react";
import Radium from "radium";
import DepartmentCard from "./departmentCard";
import { connect } from "react-redux";
import { routeActions } from "redux-simple-router";
import { Scrollbars } from "react-custom-scrollbars";
import PageSpinner from "../Common/pageSpinner";
import {
  attemptGetDepartments,
  attemptCreateDepartment,
  attemptEditDepartment,
  attemptUpdateFavorite,
  setShowFavorites,
  removeAck,
  addAck,
} from "./actions";
import { setNavHeader } from "../MainClient/Navbar/actions";
import auth from "../Login/authService";

class DepartmentOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreatingNew: false,
      creatingNewAcks: ["Diverse"],
      editingDepartmentId: null,
      searchQuery: "",
    };
  }
  componentWillMount = () => {
    this.props.dispatch(attemptGetDepartments());
    this.props.dispatch(setNavHeader(false, "Afdelinger"));
  };

  componentDidMount = () => {
    // Restore scroll position
    const savedScrollPos = sessionStorage.getItem('departmentListScrollPos');
    if (savedScrollPos && this.refs.scrollBar) {
      setTimeout(() => {
        this.refs.scrollBar.scrollTop(parseInt(savedScrollPos, 10));
      }, 0);
    }
  };

  componentWillUnmount = () => {
    // Save scroll position before leaving
    if (this.refs.scrollBar) {
      const scrollPos = this.refs.scrollBar.getScrollTop();
      sessionStorage.setItem('departmentListScrollPos', scrollPos);
    }
  };

  toggleIsCreatingNew = () => {
    this.setState({
      isCreatingNew: !this.state.isCreatingNew,
    });
    this.refs.scrollBar.scrollToTop();
  };
  setShowFavorites = (bool) => {
    this.props.dispatch(attemptGetDepartments());
    this.props.dispatch(setShowFavorites(bool));
  };
  onSaveNewDepartment = (name) => {
    if (name) {
      this.props.dispatch(
        attemptCreateDepartment(name, this.state.creatingNewAcks)
      );
    }
    this.setState({
      isCreatingNew: false,
      creatingNewAcks: ["Diverse"],
    });
  };
  scrollButtom = (evt) => {
    if (evt.top === 1) {
      this.props.dispatch(attemptGetDepartments());
    }
  };
  render() {
    const { dispatch, departments: first, isLoading, showFavorites } = this.props;
    var departments = Array.isArray(first) ? first || [] : []
    
    const role = auth.getProfile().role;
    
    const filteredDepartments = (departments || [])
      .map((department, index) => ({ ...department, originalIndex: index }))
      .filter(department => {
        const matchesFavorite = (showFavorites && department.favorite) || !showFavorites;
        const matchesSearch = !this.state.searchQuery || 
          department.name.toLowerCase().includes(this.state.searchQuery.toLowerCase());
        return matchesFavorite && matchesSearch;
      })
      .sort((a, b) => {
        const aIsTilbud = a.name.toLowerCase() === "tilbud";
        const bIsTilbud = b.name.toLowerCase() === "tilbud";
        if (aIsTilbud) return -1;
        if (bIsTilbud) return 1;
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });

    return (
      <div style={styles.container}>
        <div className="row" style={styles.innerContainer}>
          <div className="col-xs-12 text-right" style={styles.buttonsRow}>
            {auth.getProfile().role !== "Formand" ? (
              <div
                className="btn btn-primary waves-btn"
                style={styles.addCard}
                onClick={this.toggleIsCreatingNew}
              >
                {this.state.isCreatingNew ? "Annuller" : "Opret ny"}
              </div>
            ) : null}
            <input
              type="text"
              placeholder="Søg afdelinger..."
              style={styles.searchInput}
              value={this.state.searchQuery}
              onChange={(e) => this.setState({ searchQuery: e.target.value })}
            />
            <div
              className={
                showFavorites
                  ? "btn btn-default waves-btn"
                  : "btn btn-info waves-btn"
              }
              style={styles.seeAll}
              onClick={() => this.setShowFavorites(false)}
            >
              Alle
            </div>
            <div
              className={
                showFavorites
                  ? "btn btn-info waves-btn"
                  : "btn btn-default waves-btn"
              }
              style={styles.seeFavorite}
              onClick={() => this.setShowFavorites(true)}
            >
              Favoritter
            </div>
          </div>
          {filteredDepartments.length === 0 && isLoading ? (
            <PageSpinner />
          ) : (
            <Scrollbars ref="scrollBar" onScrollFrame={this.scrollButtom}>
              <div className="col-xs-12" style={styles.listContainer}>
                {this.state.isCreatingNew && (
                  <DepartmentCard
                    title={""}
                    activities={this.state.creatingNewAcks}
                    removeAck={(ackIndex, a) => {
                      if (a === "Diverse") return;
                      let asHat = this.state.creatingNewAcks;
                      asHat.splice(ackIndex, 1);
                      this.setState({ creatingNewAcks: asHat });
                    }}
                    addAck={(ackName) => {
                      if (ackName === "Diverse") return;
                      let asHat = this.state.creatingNewAcks;
                      asHat.unshift(ackName);
                      this.setState({ creatingNewAcks: asHat });
                    }}
                    linkTo={() => { }}
                    canEdit={true}
                    isCreatingNew={true}
                    onSave={this.onSaveNewDepartment}
                    toggleFavorite={() => { }}
                    favorite={true}
                  />
                )}
                {filteredDepartments.length > 0 || this.state.isCreatingNew ? (
                  <div>
                    <div style={styles.list}>
                      {filteredDepartments.map((department) => {
                      const isTilbud = department.name.toLowerCase() === "tilbud";
                      const isEditing = this.state.editingDepartmentId === department.id;
                      
                      return (
                        <div
                          key={department.id}
                          style={styles.listItem}
                          className="waves-btn"
                          onClick={() => {
                            if (!isEditing) {
                              dispatch(
                                routeActions.push(
                                  isTilbud ? "/tilbud" : "/afdeling/" + department.id
                                )
                              );
                            }
                          }}
                        >
                          <div style={styles.listItemContent}>
                            {isEditing ? (
                              <div style={styles.editContainer} onClick={(e) => e.stopPropagation()}>
                                <input
                                  type="text"
                                  defaultValue={department.name}
                                  style={styles.editInput}
                                  autoFocus
                                  ref={(input) => {
                                    if (this.state.editingDepartmentId === department.id && input) {
                                      this[`nameInput_${department.id}`] = input;
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      dispatch(
                                        attemptEditDepartment(
                                          department.id,
                                          e.target.value,
                                          department.name,
                                          department.originalIndex,
                                          department.activities
                                        )
                                      );
                                      this.setState({ editingDepartmentId: null });
                                    }
                                    if (e.key === 'Escape') {
                                      this.setState({ editingDepartmentId: null });
                                    }
                                  }}
                                />
                                {department.activities && department.activities.length > 0 && (
                                  <div style={styles.activitiesEditRow}>
                                    {department.activities.map((activity, i) => (
                                      <span key={i} style={styles.activityChip}>
                                        {activity}
                                        {activity !== 'Diverse' && (
                                          <button
                                            style={styles.removeChip}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              dispatch(removeAck(department.originalIndex, i, activity));
                                            }}
                                          >
                                            ×
                                          </button>
                                        )}
                                      </span>
                                    ))}
                                    <input
                                      type="text"
                                      placeholder="Tilføj aktivitet..."
                                      style={styles.addActivityInput}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter' && e.target.value) {
                                          e.stopPropagation();
                                          if (e.target.value !== 'Diverse') {
                                            dispatch(addAck(department.originalIndex, e.target.value));
                                          }
                                          e.target.value = '';
                                        }
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div style={styles.listItemLeft}>
                                <div style={styles.departmentName}>{department.name}</div>
                              </div>
                            )}
                            <div style={styles.listItemRight}>
                              {isEditing ? (
                                <button
                                  key={`save-${department.id}`}
                                  style={styles.saveBtn}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const nameInput = this[`nameInput_${department.id}`];
                                    const newName = nameInput ? nameInput.value : department.name;
                                    dispatch(
                                      attemptEditDepartment(
                                        department.id,
                                        newName,
                                        department.name,
                                        department.originalIndex,
                                        department.activities
                                      )
                                    );
                                    this.setState({ editingDepartmentId: null });
                                  }}
                                >
                                  <i className="fa fa-check" />
                                </button>
                              ) : null}
                              {!isEditing && !isTilbud && (
                                <button
                                  key={`edit-${department.id}`}
                                  style={styles.editBtn}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({ editingDepartmentId: department.id });
                                  }}
                                >
                                  <i className="fa fa-pencil" />
                                </button>
                              )}
                              {!isEditing && (
                                <button
                                  key={`fav-${department.id}`}
                                  style={styles.favoriteBtn}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(
                                      attemptUpdateFavorite(
                                        department.originalIndex,
                                        department.id,
                                        !department.favorite
                                      )
                                    );
                                  }}
                                >
                                  <i className={department.favorite ? "fa fa-star" : "fa fa-star-o"} style={styles.starIcon} />
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    </div>
                    <div style={styles.countDisplay}>
                      Viser {filteredDepartments.length} afdeling{filteredDepartments.length !== 1 ? 'er' : ''}
                    </div>
                  </div>
                ) : (
                  <div style={styles.emptyState}>
                    <img
                      style={styles.emptyState.img}
                      src="/images/emptyStates/projectCardsNoFavourites.gif"
                      alt="Ingen favoritter tilføjet"
                    />
                  </div>
                )}
              </div>
            </Scrollbars>
          )}
        </div>
      </div>
    );
  }
}

var styles = {
  container: {
    position: "absolute",
    top: "0",
    left: "0",
    padding: "100px 12px 0 12px",
    width: "100%",
    height: "100%",
    marginRight: "auto",
    marginLeft: "auto",
    "@media (min-width: 1200px)": {
      maxWidth: "1170px",
      left: "50%",
      marginLeft: "-585px",
    },
  },
  innerContainer: {
    height: "100%",
  },
  buttonsRow: {
    paddingTop: "8px",
    paddingBottom: "7px",
    position: "absolute",
    top: "50px",
  },
  listContainer: {
    padding: "20px",
  },
  list: {
    display: "flex",
    flexDirection: "column",
  },
  listItem: {
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
    padding: "16px 20px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginBottom: "8px",
    ":hover": {
      backgroundColor: "#f5f5f5",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    },
  },
  listItemContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "left",
  },
  listItemLeft: {
    flex: 1,
  },
  listItemRight: {
    display: "flex",
    alignItems: "center",
  },
  departmentName: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#333",
  },
  editBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px 8px",
    marginRight: "8px",
    color: "#666",
    fontSize: "16px",
    lineHeight: "1",
    display: "flex",
    alignItems: "center",
    ":hover": {
      color: "#333",
    },
  },
  saveBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px 8px",
    marginRight: "8px",
    color: "#4CAF50",
    fontSize: "20px",
    lineHeight: "1",
    display: "flex",
    alignItems: "center",
    ":hover": {
      color: "#45a049",
    },
  },
  editInput: {
    flex: 1,
    fontSize: "18px",
    fontWeight: "600",
    padding: "8px",
    border: "2px solid #2196F3",
    borderRadius: "4px",
    outline: "none",
    marginBottom: "8px",
  },
  editContainer: {
    flex: 1,
  },
  activitiesEditRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: "4px",
  },
  activityChip: {
    padding: "4px 10px",
    borderRadius: "12px",
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
    fontSize: "12px",
    fontWeight: "500",
    display: "inline-flex",
    alignItems: "center",
    marginRight: "6px",
    marginBottom: "4px",
  },
  removeChip: {
    background: "none",
    border: "none",
    color: "#1976d2",
    fontSize: "16px",
    cursor: "pointer",
    padding: "0",
    marginLeft: "4px",
    lineHeight: "1",
  },
  addActivityInput: {
    border: "1px dashed #ccc",
    borderRadius: "12px",
    padding: "4px 10px",
    fontSize: "12px",
    outline: "none",
    minWidth: "120px",
    marginBottom: "4px",
  },
  favoriteBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    color: "#ffc107",
    fontSize: "24px",
    lineHeight: "1",
    display: "flex",
    alignItems: "center",
  },
  starIcon: {
    fontSize: "20px",
  },
  countDisplay: {
    padding: "16px 20px",
    textAlign: "center",
    color: "#666",
    fontSize: "14px",
    fontWeight: "500",
  },
  seeAll: {
    width: "50px",
    height: "35px",
    lineHeight: "35px",
    padding: "0px",
    borderTopRightRadius: "0px",
    borderTopLeftRadius: "2px",
    borderBottomLeftRadius: "2px",
    borderBottomRightRadius: "0px",
  },
  seeFavorite: {
    width: "100px",
    height: "35px",
    lineHeight: "35px",
    padding: "0px",
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "2px",
    borderBottomRightRadius: "2px",
    borderBottomLeftRadius: "0px",
  },
  addCard: {
    width: "146px",
    padding: "0px",
    height: "35px",
    lineHeight: "35px",
    float: "left",
    borderRadius: "2px",
  },
  searchInput: {
    height: "35px",
    padding: "0 12px",
    border: "1px solid #ccc",
    borderRadius: "2px",
    outline: "none",
    fontSize: "14px",
    marginRight: "8px",
    width: "200px",
    lineHeight: "35px",
    verticalAlign: "middle",
  },
  emptyState: {
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
    marginTop: "100px",
    img: {
      borderRadius: "2px",
    },
  },
};

function selectProps(state) {
  return {
    ...state.departmentReducer,
  };
}

export default connect(selectProps)(Radium(DepartmentOverview));



// WEBPACK FOOTER //
// ./src/App/Department/index.jsx